import {useState, useEffect} from "react"
import {PaymentProvider, BasketTotalWithBreakDown, Address} from "@irati/types"
import {BasketInputItem} from "@irati/types/ops"
import basketStream, {OnError, OnComplete} from "."

interface Props {
  onError?: OnError
  onComplete?: OnComplete
}

export interface UseBasket {
  items: BasketInputItem[]
  paymentProvider: PaymentProvider
  breakdown: BasketTotalWithBreakDown
  isLoading: boolean
  isCashback: boolean
  shippingAddress: Address
}

export default function useBasket({onError, onComplete}: Props = {}) {
  const [basket, setBasket] = useState<UseBasket>({
    items: basketStream.items,
    paymentProvider: basketStream.paymentProvider,
    breakdown: basketStream.breakdown,
    isCashback: false,
    isLoading: false,
    shippingAddress: basketStream.shippingAddress
  })

  useEffect(() => {
    const subscription = basketStream.subscribe(
      ({items, breakdown, isLoading, shippingAddress}) => {
        setBasket({
          paymentProvider: basketStream.paymentProvider,
          isCashback: basketStream.isCashback,
          items,
          breakdown,
          isLoading,
          shippingAddress
        })
      },
      onError,
      onComplete
    )

    return () => {
      return subscription.unsubscribe()
    }
  }, [])

  return basket
}
